import {
  Apollo_gql,
  GraphMutationBuilderPayload,
  GraphQueryPayload,
  createMutation,
  graphQlPaginationFields,
  graphQlTake,
} from '@camelot/server';
import {
  ProjectCreationPayloadInput,
  ProjectModifierPayloadInput,
  ProjectStatus,
  projectAddressProps,
  projectProps,
  tenantProps,
} from '@camelot/services';

export function GET_MY_PROJECTS(filters?: { statusList?: ProjectStatus[]; take?: number }): GraphQueryPayload {
  const where =
    filters?.statusList && filters.statusList.length > 0 ? `where: { status: { in: [${filters.statusList}] } }` : '';
  return {
    query: Apollo_gql`
        query Projects {
          projects(${graphQlTake(filters?.take)}, ${where}) {
            items {
              ${projectProps.get('id')}
              ${projectProps.get('name')}
              ${projectProps.get('status')}
              ${projectProps.get('projectPictureUrl')}
              ${projectProps.get('pictureDocumentId')}
              ${projectProps.get('projectAddress')} {
                ${projectAddressProps.get('city')}
                ${projectAddressProps.get('postCode')}
                ${projectAddressProps.get('street')}
              }
              ${projectProps.get('tenantInformation')} {
                ${tenantProps.get('id')}
                ${tenantProps.get('tenantName')}
                ${tenantProps.get('projectId')}
              }
            }
            ${filters?.take ? graphQlPaginationFields() : ''}
          }
        }
      `,
    variables: {},
  };
}
export function GET_PROJECT_BY_ID(id: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
        query GetProjectById($id: UUID!) {
          projectById(id: $id) {
            ${projectProps.get('id')}
            ${projectProps.get('name')}
            ${projectProps.get('status')}
            ${projectProps.get('projectPictureUrl')}
            ${projectProps.get('pictureDocumentId')}
            ${projectProps.get('projectAddress')} {
              ${projectAddressProps.get('city')}
              ${projectAddressProps.get('postCode')}
              ${projectAddressProps.get('street')}
            }
            ${projectProps.get('tenantInformation')} {
              ${tenantProps.get('id')}
              ${tenantProps.get('tenantName')}
              ${tenantProps.get('projectId')}
            }
          }
        }
      `,
    variables: {
      id: id,
    },
  };
}

export function GET_LIGHT_PROJECTS(ids: string[]): GraphQueryPayload {
  return {
    query: Apollo_gql`
        query Projects($ids: [UUID]!) {
         projects(where: { id: { in: $ids } }, ${graphQlTake()}) {
            items {
              ${projectProps.get('id')}
              ${projectProps.get('name')}
            }
          }
        }
      `,
    variables: {
      ids: ids,
    },
  };
}

export function GET_SEARCH_PROJECTS(filter: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
        query SearchProjects($filter: String!) {
          searchProjects(filter: $filter, ${graphQlTake()}) {
            items {
              ${projectProps.get('id')}
              ${projectProps.get('name')}
            }
          }
        }
      `,
    variables: {
      filter,
    },
  };
}

export function GET_PROJECTS(where: string, props: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
        query Projects {
         projects(${where}, ${graphQlTake()}) {
            items {
              ${props}
            }
          }
        }
      `,
    variables: {},
  };
}

export function GET_PROJECT_TENANT_ROUTE(projectId: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
        query ProjectTenantRoute($projectId: UUID!) {
          projectTenantRoute(projectId: $projectId)
        }
      `,
    variables: {
      projectId: projectId,
    },
  };
}

export function GET_PROJECT_DOCUMENT_IDS(projectId: string) {
  return {
    query: Apollo_gql`
        query ProjectDocumentIds($projectId: UUID!) {
         projectDocumentIds(projectId: $projectId)
        }
      `,
    variables: {
      projectId: projectId,
    },
  };
}

const projectMutationProps = `
  ${projectProps.get('id')}
  ${projectProps.get('name')}
  ${projectProps.get('status')}
  ${projectProps.get('description')}
  ${projectProps.get('companyId')}
  ${projectProps.get('clientReference')}
  ${projectProps.get('parentProjectId')}
  ${projectProps.get('contactId')}
  ${projectProps.get('addressId')}
  ${projectProps.get('departmentId')}
  ${projectProps.get('projectAddress')} {
    ${projectAddressProps.get('id')}
    ${projectAddressProps.get('city')}
    ${projectAddressProps.get('postCode')}
    ${projectAddressProps.get('street')}
    ${projectAddressProps.get('country')}
  }
  ${projectProps.get('tenantInformation')} {
    ${tenantProps.get('id')}
    ${tenantProps.get('tenantName')}
    ${tenantProps.get('projectId')}
  }
`;

export function CREATE_PROJECT(payload: ProjectCreationPayloadInput): GraphMutationBuilderPayload {
  return createMutation('createProject', {
    argument: 'projectCreationPayload',
    props: projectMutationProps,
    value: payload,
  });
}

export function UPDATE_PROJECT(
  payload: Partial<ProjectModifierPayloadInput> & { id: string }
): GraphMutationBuilderPayload {
  return createMutation('updateProject', {
    argument: 'projectModifierPayload',
    props: projectMutationProps,
    value: payload,
  });
}

export function LINK_PROJECT_DOCUMENTS(projectId: string, documentIds: string[]): GraphMutationBuilderPayload {
  return createMutation('linkProjectDocuments', {
    args: {
      documentIds: { type: '[UUID!]!', value: documentIds },
      projectId: { type: 'UUID!', value: projectId },
    },
    props: '',
  });
}
